import '../../style/';
import '../../icon/style/';
import './index.less';



// WEBPACK FOOTER //
// ./components/notice-bar/style/index.tsx